import { Container, Typography, makeStyles, Box, Button } from '@material-ui/core';

// layout
import HomeLayout from 'layouts/HomeLayout';

// action
import { getOneDoc } from 'context/actions/docs';

// components
import BackButton from '/components/shared/BackButton';
import PdfViewer from '/components/shared/PdfViewer';
import WysiwygViewer from 'components/shared/TextEditorViewer';

const useStyles = makeStyles(() => ({
    root: {
        marginTop: 30,
        minHeight: '90vh',
    },
    list: {
        paddingBottom: 30,
    },
    content: {
        marginTop: 10,
        marginBottom: 20,
        backgroundColor: 'whitesmoke',
        borderRadius: 4,
        padding: 50,
    },
    titleBox: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 10,
    },
}));

const DocsPage = ({ doc }) => {
    const classes = useStyles();

    return (
        <Container maxWidth="lg" className={classes.root}>
            <Box className={classes.titleBox}>
                <BackButton />
                <Typography style={{ fontSize: 18, marginLeft: 10 }} variant="subtitle1">
                    {doc.title}
                </Typography>
            </Box>
            <Box
                className={classes.titleBox}
                style={{ marginBottom: 0, justifyContent: 'space-between' }}
            >
                <Typography variant="h3" style={{ fontSize: 12 }}>
                    Нийтэлсэн огноо: <br /> {doc.own_date.split('T')[0]}
                </Typography>
                <Button
                    style={{ backgroundColor: '#cbdbff', color: '#6f83af', padding: '6px 18px' }}
                >
                    <a target="_blank" href={doc.file} rel="noreferrer">
                        Хавсралт файл
                    </a>
                </Button>
            </Box>
            <Box className={classes.content}>
                <WysiwygViewer data={doc.content} />
                <Box style={{ marginTop: 30 }}>
                    <PdfViewer url={doc.file} />
                </Box>
            </Box>
        </Container>
    );
};

export async function getServerSideProps(context) {
    const doc = await getOneDoc(context.query.id);
    return {
        props: { doc }, // will be passed to the page component as props
    };
}

DocsPage.Layout = HomeLayout;

export default DocsPage;
